import { Component } from '@angular/core';

@Component({
  selector: 'app-trips-reports',
  templateUrl: './trips-reports.component.html',
  styleUrls: ['./trips-reports.component.scss'],
  standalone: false,
})
export class TripsReportsComponent {}
